// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';

import Arrow from '../../assets/images/arrow.svg'

const colors: any = {
  red: '#FF5B5B',
  green: '#29D16C',
  yellow: '#FCA032',
};

export const S = {
  ShadowBoxContainer: styled.div`
    max-width: 1110px;
    width: 100%;
    margin-bottom: 71px;
  `,
  ShadowBox: styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 10px;
    margin-top: 24px;
  `,
  Container: styled.div`
    margin: 30px 0;
    background: #F9F9F9 0% 0% no-repeat padding-box;
    border-radius: 10px;
    padding: 34px
  `,
  ContainerTopGrid: styled.div`
    display: grid;
    grid-template-columns:
      [first]
      minmax(0, 100fr) minmax(0, 100fr) minmax(0, 150fr)
      [end]
    ;
    grid-row-gap: 10px;
    column-gap: 20px;
  `,
  ContainerText: styled.span<{ color?: string; align?: string }>`
    font: 14px/21px Noto Sans TC;
    letter-spacing: 0.22px;
    color: ${({ color }) => (color && colors[color]) || '#444444' };
    text-align: ${({ align }) => align || 'left' };
  `,
  ContainerProductTitle: styled.span<{ color?: string; align?: string }>`
    font-weight: 500;
    font-size: 18px;
    line-height: 32px;
    letter-spacing: 0.29px;
    color: ${({ color }) => (color && colors[color]) || '#444444' };
    text-align: ${({ align }) => align || 'left' };
  `,
  LoadingContainer: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 100px
  `,
  LoadingText: styled.span`
    font-weight: 500;
    font-size: 18px;
    line-height: 32px;
    letter-spacing: 0.29px;
    margin: 20px 0;
    color: #BBBBBB;
  `,
  ContainerBottomGrid: styled.div`
    display: grid;
    grid-template-columns:
      [first]
      minmax(0, 450fr) minmax(0, 100fr) minmax(0, 100fr) minmax(0, 100fr)
      [end]
    ;
    grid-row-gap: 10px;
    column-gap: 60px;
  `,
  TableLine: styled.div`
    grid-column-start: first;
    grid-column-end: end;
    border-bottom: 1px solid rgb(226 226 226);
  `,
  TableText: styled.span`
    font: 14px/21px Noto Sans TC;
    letter-spacing: 0.22px;
    color: #444444;
  `,
  ShowTableButton: styled.span<{ active: boolean }>`
    display: flex;
    position: relative;
    justify-content: center;
    padding: 10px;
    cursor: pointer;
    font: 14px/21px Noto Sans TC;
    letter-spacing: 0.22px;
    color: #a0a0a0;
    transition: color 1s;

    &:hover{
      color: #444444;
    }

    &:before{
      content: "";
      float: left;
      display: block;
      background: url(${Arrow}) no-repeat;
      width: 10px;
      height: 10px;
      margin-right: 10px;
      margin-top: ${(props) => props.active ? '4px;' : '9px;'}
      transform : ${(props) => props.active ? 'rotate(180deg);' : 'rotate(0deg);'}
    }
  `,
  CancelButton: styled.span`
    font: 14px/21px Noto Sans TC;
    letter-spacing: 0.22px;
    color: #444444;
    cursor: pointer;
    display: flex;
    justify-content: center;
    transition: color 1s;

    &:hover{
      color: #FF5B5B;
    }
  `
};
